<script>
import InfoTooltip from '@comp/InfoTooltip.vue'
import { STATUS_COLORS } from '@src/constants'

export default {
  name: 'StatusesInfoTooltip',
  components: {
    InfoTooltip,
  },
  data () {
    return {
      colors: STATUS_COLORS,
    }
  },
}
</script>
<template>
  <InfoTooltip
    location="bottom"
    :max-width="600"
  >
    <div>
      <span>{{ $gettext('Statuses describing what is being done on your task right now') }}</span>
      <ul>
        <li>
          <v-chip
            :color="colors.LIGHTBLUE"
            variant="elevated"
            size="x-small"
          >
            {{ $gettext('READY') }}
          </v-chip>
          {{ $gettext(':') }} {{ $gettext('your task is about to run') }}
        </li>
        <li>
          <v-chip
            :color="colors.LIGHTGREEN"
            variant="elevated"
            size="x-small"
          >
            {{ $gettext('RUNNING') }}
          </v-chip>
          {{ $gettext(':') }} {{ $gettext('your task is running') }}
        </li>
        <li>
          <v-chip
            :color="colors.GREEN"
            variant="elevated"
            size="x-small"
          >
            {{ $gettext('SUCCESSFUL') }}
          </v-chip>
          {{ $gettext(':') }} {{ $gettext('your task is finished, the results are available') }}
        </li>
        <li>
          <v-chip
            :color="colors.RED"
            variant="elevated"
            size="x-small"
          >
            {{ $gettext('FAILED') }}
          </v-chip>
          <!-- eslint-disable-next-line max-len -->
          {{ $gettext(':') }} {{ $gettext('something went wrong on our side. Please retry and if it doesn\'t work again, contact us so we can fix that.') }}
        </li>
      </ul>
    </div>
  </InfoTooltip>
</template>
<style lang="scss" scoped>
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  padding-left: 1ch;
}
</style>
